import { reactToCwp } from '../../../../common/react-utils'
import { LandingPage } from './LandingPage'

export default reactToCwp(LandingPage)
